import { brandService } from '../../services'
import queryString from 'query-string'
import dynamic from 'next/dynamic';
import { serverLocationDetector } from '../../utils/locationDetector';
const Layout = dynamic(() => import('../../components/_App/Layout'))
const Brands = dynamic(() => import('./../../templates/Brands'))

export default function BrandsPage({data, isAppleMobile, page}) {
 
    return (
        <Layout
            isAppleMobile = {isAppleMobile} 
            seo={{
                description: `Discover, rate & review cannabis brands & their products.${page ? ' Page '+page : ''}`,
                image:'/static/icons/favicon.png',
                title: `${page ? 'Page '+page+' - ' : ''}Discover Cannabis Brands & Products | Weedzly`,
                url:'https://weedzly.com/brands'
            }}
        >
            <Brands data={data} />
        </Layout>
    )
}

export async function getServerSideProps(context){
    let isAppleMobile = (context.req
        ? context.req.headers['user-agent']
        : navigator.userAgent).match(
          /iPhone|iPad|iPod/i
        )
    await serverLocationDetector(context)
    const data = await brandService.getPaginated(`?${
        queryString.stringify({...context.query, ...{ size: 48}}, {
            arrayFormat: 'bracket', 
            skipEmptyString: true
        })
    }`)
    
    return {
        props: {
            isAppleMobile,
            data,
            page: (context.query && context.query.page) ? context.query.page : null
        }
    } 

}
